module.exports = __webpack_public_path__ + "static/media/next2.a6c8d99c.svg";